import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../_helpers';



// create slice

const name = 'attribute';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers= (builder) => {
    createExtraReducers(builder);
}
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const attributeActions = { ...slice.actions, ...extraActions };
export const attributeReducer = slice.reducer;


// implementation

function createInitialState() {
    return {
        attribute:{},
        attributeList: [],
        error: null,
           isLoading:false,
        attributeResponse: [],
        deleteAttributeResponse:[]
    }
}

function createExtraActions() {
     const baseUrl = `${process.env.REACT_APP_API_URL}/Attribute`;
    return {
        getAttributeAll: getAttributeAll(),
        getAttributeById:getAttributeById(),
        saveAttribute: saveAttribute(),
        deleteAttribute:deleteAttribute(),
    };

    function getAttributeAll() {
        return createAsyncThunk(
            `${name}/getAttributeAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetAttributeDetails`)
        );
    }
     function getAttributeById() {
        return createAsyncThunk(
            `${name}/getAttributeById`,
             async (detail) => await fetchWrapper.get(`${baseUrl}/GetAttributeDetails?AttributeID=`+detail.AttributeID)
        );
    }

    function saveAttribute() {
        return createAsyncThunk(
            `${name}/saveAttribute`,
             async (addFormData) => await fetchWrapper.post(`${baseUrl}/InsertUpdateAttribute`, addFormData )
        );
    }

    function deleteAttribute()
    {
        return createAsyncThunk(
            `${name}/deleteAttribute`,
             async (detail) => await fetchWrapper.post(`${baseUrl}/DeleteAttribute?AttributeID=${detail.AttributeID}&DeletedBy=${detail.DeletedBy}`)
          
        );
    }
}

function createExtraReducers(builder) {
    builder
        .addCase(extraActions.getAttributeAll.pending, (state) => {
            state.isLoading = false;
            state.error = "";
        })
        .addCase(extraActions.getAttributeAll.fulfilled, (state, action) => {
            state.isLoading = true;
            state.attributeList = action.payload || [];
            state.attributeResponse = [];
            state.deleteAttributeResponse = [];
        })
        .addCase(extraActions.getAttributeAll.rejected, (state, action) => {
            state.isLoading = true;
            state.error = { error: action.error };
        })
        .addCase(extraActions.getAttributeById.pending, (state) => {
            state.attribute = { loading: true };
        })
        .addCase(extraActions.getAttributeById.fulfilled, (state, action) => {
            state.attribute = action.payload?.[0] || {};
            state.attributeResponse = [];
            state.deleteAttributeResponse = [];
        })
        .addCase(extraActions.getAttributeById.rejected, (state, action) => {
            state.attribute = { error: action.error };
        })
        .addCase(extraActions.saveAttribute.pending, (state) => {
            state.attributeResponse = { loading: true };
        })
        .addCase(extraActions.saveAttribute.fulfilled, (state, action) => {
            state.attributeResponse = action.payload;
            state.deleteAttributeResponse = [];
        })
        .addCase(extraActions.saveAttribute.rejected, (state, action) => {
            state.attributeResponse = { error: action.error };
        })
        .addCase(extraActions.deleteAttribute.pending, (state) => {
            state.attributeResponse = { loading: true };
        })
        .addCase(extraActions.deleteAttribute.fulfilled, (state, action) => {
            state.deleteAttributeResponse = action.payload;
            state.attributeResponse = [];
        })
        .addCase(extraActions.deleteAttribute.rejected, (state, action) => {
            state.deleteAttributeResponse = { error: action.error };
        });
}
































